export type EnglishAccent = "us" | "uk";

export const DEFAULT_ENGLISH_ACCENT: EnglishAccent = "us";
export const BRITISH_ENGLISH_AUDIO_NAMESPACE = "audio/en_gb";
export const CANONICAL_ENGLISH_AUDIO_NAMESPACE = "audio/en";

export function normalizeEnglishAccent(value?: string | null): EnglishAccent {
  const normalized = String(value || "").trim().toLowerCase().replace("-", "_");
  return normalized === "uk" || normalized === "gb" || normalized === "en_gb"
    ? "uk"
    : DEFAULT_ENGLISH_ACCENT;
}

export function languageSupportsAudioAccent(languageCode?: string | null): boolean {
  return String(languageCode || "").trim().toLowerCase() === "en";
}

export function resolveEnglishAudioAccent(
  languageCode?: string | null,
  englishAccent?: string | null,
): EnglishAccent | undefined {
  return languageSupportsAudioAccent(languageCode)
    ? normalizeEnglishAccent(englishAccent)
    : undefined;
}
